import React from 'react';
import Logo from './Logo';
import { rolarAteSecao } from './Header';
import { reabrirAvisoDeCookies } from './AvisoDeCookies';
import { Link, useIdioma } from '../i18n';
import '../styles/Footer.css';

/* Os títulos das colunas estavam em português numa interface em inglês
   ("Produto", "Empresa") — agora vêm do dicionário como o resto. */
const COLUNAS = [
  {
    titulo: 'site.produto',
    links: [
      { to: '/#features', chave: 'site.recursos' },
      /* Os dois links de `/docs` saíram daqui: a documentação passou a viver
         só na área logada, e ambos apontavam para uma rota que nunca existiu.
         "Acesso à API" foi junto — não há API pública a documentar hoje. */
      { to: '/#pricing', chave: 'site.precos' }
    ]
  },
  {
    titulo: 'site.empresa',
    links: [
      { to: '/blog', chave: 'site.blog' },
      { to: '/#contact', chave: 'site.contato' }
    ]
  },
  {
    titulo: 'site.legal',
    links: [
      { to: '/privacy-policy', chave: 'site.privacidade' },
      { to: '/terms-of-service', chave: 'site.termos' }
    ]
  }
];

const Footer = () => {
  const { t } = useIdioma();

  return (
    <footer className="footer">
      <div className="sp-wrap footer-inner">
        <div className="footer-brand">
          <Logo size={24} />
          <div className="footer-copy">{t('site.direitos', { ano: new Date().getFullYear() })}</div>
        </div>

        {COLUNAS.map((col) => (
          <div className="footer-col" key={col.titulo}>
            <span className="sp-label">{t(col.titulo)}</span>
            {col.links.map((l) => (
              <Link key={l.to} to={l.to} onClick={(e) => rolarAteSecao(e, l.to)}>
                {t(l.chave)}
              </Link>
            ))}
            {col.titulo === 'site.legal' && (
              <button type="button" onClick={reabrirAvisoDeCookies}>
                {t('cookies.titulo')}
              </button>
            )}
          </div>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
